<template>
    <div class="template-base">
        <MessageBoxV3 v-show="messageBox_show" ref="refMessageBox" />
        <Header Title="Square Orders" :iconPath="'/images/icons/square-pos.png'" class="div-header" ></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" ></Button>

            <!-- Header-->
            <div style="display:flex; height: 50px;">
                <div class="station-log-input-container">
                    <span>Date</span>
                    <input style="height:25px" class="station-log-input-item-select" type="date" v-model="dteDay" :disabled="autoPrint" />
                </div>
                <div class="station-log-input-container" style="display: flex;justify-content: flex-end ;" v-if="!fetchingData && !autoPrint">
                    <button class="administrator-button station-log-button" @click="loadTransactions">
                        View
                    </button>
                </div>
                <div class="station-log-input-container" style="display: flex;justify-content: flex-end;flex-direction: row;margin: auto; padding-top:20px" v-if="!fetchingData">
                    <input type="checkbox" id="autoPrint" value="autoPrint" v-model="autoPrint" aria-label="Prints new pincodes as they are sold on Square" @click="autoPrintClicked($event.target.checked)"/>
                    <label for="autoPrint">Auto print purchased pin codes</label>
                </div>
            </div>
        </div>
        <div class="station-log-content div-body" style="overflow-y: auto;">
            <table class="report-div-table" cellspacing="0">
                <tr class="report-div-table-row">
                    <th class="report-div-table-col" style="width: 10%">Date Time</th>
                    <th class="report-div-table-col" style="width: 5%">Receipt</th>                    
                    <th class="report-div-table-col" style="width: 5%;text-align:right">Price</th>                    
                    <th class="report-div-table-col" style="width: 8%">Card Type</th>
                    <th class="report-div-table-col" style="width: 10%">Card Number</th>
                    <th class="report-div-table-col" style="width: 10%">Member Email</th>
                    <th class="report-div-table-col" style="width: 10%">Member Number</th>                    
                    <th class="report-div-table-col" style="width: 8%">Pincodes</th>
                    
                                        
                </tr>

                <tr v-for="row in dataReport" :key="row.description" class="report-div-table-row">
                    <td class="report-div-table-col">{{ row.timestampDisplay }}</td>                                    
                    <td class="report-div-table-col">{{ row.receiptNumber }}</td>                    
                    <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.price) }}</td>                    
                    <td class="report-div-table-col">{{ row.cardType }}</td>
                    <td class="report-div-table-col">{{ row.cardNumber }}</td>
                    <td class="report-div-table-col">{{ row.memberEmail }}</td>
                                    
                    
                    <td class="report-div-table-col" v-if="row.reloadStatus == SquareOrderActionTypes.NeedsAction"><button @click="selectMember(row)" style="width:unset" class="button-link">Select Member</button></td>
                    <td class="report-div-table-col" v-else>{{ row.memberNumber }}</td>                    
                    

                    <td class="report-div-table-col" v-if="row.pincodeStatus == SquareOrderActionTypes.NoAction"></td>                    
                    <td class="report-div-table-col" v-else><button @click="printPincodes(row)" style="width:unset" class="button-link">Print</button></td>
                </tr>
            </table>
        </div>
        <iframe ref="refPrintFrame" src="" frameborder="0" width="0px" height="0px" ></iframe>
    </div>
    <MemberReload ref="refMemberReload" v-show="showMemberReload" @on-close="closeReload()" :disableBalanceReload="false" :allowClickToAdd="true" :useSquareOrder="true"/>
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import MessageBoxV3 from "@/views/components/Shared/MessageBoxV3";
import ButtonModel from "@/common/models/ButtonModel";
import { ref } from "vue";
import { getCurrentInstance, onMounted, onUnmounted } from "@vue/runtime-core";
import { storage } from "@/common/storage";
import Helper from "@/common/helper";
import Utilities from "@/common/utilities";
import apiLogging from "@/api/apiLogging";
import { SquareOrderActionTypes } from "@/common/enums";
import MemberReload from "@/views/components/Shared/MemberReload";
// import PortalUserModel from "@/common/models/PortalUserModel";

export default {
    components: { Header, Button, MessageBoxV3, MemberReload },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);
        const dteDay = ref(storage.getReportDateStart());

        const messageBox_show = ref(false);
        const refMessageBox = ref(null);

        const dataReport = ref([]);
        const refPrintFrame = ref(null)

        const refMemberReload = ref(null);
        const showMemberReload = ref(false);
        
        
        const autoPrint = ref(false);

        // var portalUser = PortalUserModel.fromToken();

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        let intervalId;

        onMounted(async () => {
            
        })

        onUnmounted (() => {
            clearInterval(intervalId)
        })

        const autoPrintClicked = async (value) => {

            if (value){
                await loop()
            } else {
                clearInterval(intervalId)
            }
        }

        let maxTimestamp = 0
        const loop = async () => {
            intervalId = setInterval(async () => {
                console.log("In Loop")

                if (maxTimestamp == 0) {
                    maxTimestamp = Date.now()                
                }
                
                const newOrders = await apiLogging.getNewSquarePosOrders(maxTimestamp);
                if (newOrders.length >0)
                {
                    dataReport.value.push(...newOrders)
                    maxTimestamp = Math.max(...newOrders.map(x => x.selectTimestamp))
                }

                newOrders.forEach(async (order) => {
                    if (order.pincodeStatus != SquareOrderActionTypes.NoAction) {
                        await printPincodes(order)
                    }
                })                
            }, 5000)            
        }

        const loadTransactions = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                storage.setReportDateStart(dteDay.value);
                storage.setReportDateEnd(dteDay.value);
                fetchingData.value = true;
                dataReport.value = await apiLogging.getSquarePosLogs(storage.getReportDateStart(), storage.getReportDateStart());
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading", err]);
            } finally {
                emitter.emit("server-call-stop");
                fetchingData.value = false;
            }
        };


        const selectMember = async (order) => {
            console.log(order)

            refMemberReload.value.setMember();
            refMemberReload.value.selectData = {
                globalId : order.orderId,
                keyCaption: Utilities.toCurrency(order.toAccountTotal),
                orderDate: new Date(order.timestamp),
                toAccount: order.toAccountTotal
            };
            showMemberReload.value = true;            
        };

        const printPincodes = async (order) => {
            refPrintFrame.value.src = `pin-ticket-order.html?pagePerPin=true&batchId=${encodeURIComponent(order.pincodeBatchId)}`;
        };

        const closeReload = async () => {
            showMemberReload.value = false
            await loadTransactions()
        }
         

        return {
            SquareOrderActionTypes,
            btnExit,
            messageBox_show,
            refMessageBox,
            loadTransactions,
            printPincodes,
            selectMember,
            refPrintFrame,
            dteDay,
            Helper,
            Utilities,
            fetchingData,
            dataReport,
            refMemberReload,
            showMemberReload,
            closeReload,
            autoPrint,
            autoPrintClicked
        };
    }
};
</script>

<style scoped>
.refund-button {
    /* background-color: cornflowerblue; */
    color: var(--button-color);
    padding: 10px;
    /* margin-right: 10px;
    width: 75px; */
    cursor: pointer;
}

.station-log-content {
    margin: 5px;
    height: 100%;
}
.station-log-stations {
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-right: 25px;
}

.station-log-transactions-container {
    width: 100%;
    height: 60%;
    border: 1px solid black;
    overflow-y: auto;
}

.station-log-item {
    width: 300px;
    min-width: 100px;
}
.station-log-input-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    /* margin: 10px 0px; */
    padding: 0px 10px;
}

.station-log-input-item {
    width: 150px;
}

.station-log-input-item-select {
    width: 161px;
    height: 30px;
}

.station-log-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 8px;
    margin-right: 10px;
    /* width: 75px;
    height: 30px;
    cursor: pointer; */
}
</style>
